import { render } from "./my-exception.vue?vue&type=template&id=225d60a1"
import script from "./my-exception.vue?vue&type=script&lang=js"
export * from "./my-exception.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__